import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';

import Container from '../../containers/Container';
import Grid from '../../components/Grid';
import Button from '../../components/Button';
import PdfLoader from '../../utils/PdfLoader';
import { ReactComponent as ActorsDesk } from '../../res/actors_desk.svg';
import { ReactComponent as ActorsResp } from '../../res/actors_resp.svg';
import styles from './styles';

class HomeActeurs extends React.Component {
  renderHexa() {
    const { classes } = this.props;
    return (
      <>
        <div className={`${classes.hexaContainer} ${classes.hexaContainer1}`}>
          <svg className={classes.hexa1} width="185.49" height="173.494" viewBox="0 0 185.49 173.494">
            <path
              fill="#601c70"
              d="M113.165,0l37.722,65.768-37.722,65.768H37.722L0,65.768,37.722,0Z"
              transform="translate(42.824) rotate(19)"
            />
          </svg>
        </div>
        <div className={`${classes.hexaContainer} ${classes.hexaContainer2}`}>
          <svg className={classes.hexa2} width="110.121" height="102.154" viewBox="0 0 110.121 102.154">
            <path
              fill="#ef7d00"
              d="M68.25,0,91,39.5,68.25,79H22.75L0,39.5,22.75,0Z"
              transform="translate(0 26.606) rotate(-17)"
            />
          </svg>
        </div>
      </>
    );
  }

  render() {
    const { classes, data } = this.props;
    const { acteurs: block } = data.home;
    return (
      <Container className={classes.container} id="home-acteurs" zIndex={3}>
        {this.renderHexa()}
        <Typography variant="h3" className={classes.title}>
          {parse(block.title)}
        </Typography>
        <div className={classes.titleSep}></div>
        <Grid spacing={3}>
          <Grid.Item key="desc" xs={12} sm={12} md={5}>
            <Typography variant="subtitle1" className={classes.desc}>
              {parse(block.desc)}
            </Typography>
            <div className={classes.buttonContainer}>
              <Button onClick={PdfLoader(block.pdf)} color="yellow2">
                {parse(block.button)}
              </Button>
            </div>
          </Grid.Item>
          <Grid.Item key="forme" xs={12} sm={12} md={7}>
            <div className={classes.formeRow}>
              <div className={classes.formeContainer}>
                <ActorsDesk className={classes.graphDesk} />
                <ActorsResp className={classes.graphResp} />
              </div>
            </div>
          </Grid.Item>
        </Grid>
      </Container>
    );
  }
}

HomeActeurs.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HomeActeurs);
